(ns web3.components.progress
  (:require [web3.view :as v]
            [web3.constants :as constants]))

(defn indeterminate [{:keys [height
                             bg-color
                             color
                             style]
                      :or {height 4
                           color (:blue constants/colors)
                           bg-color "rgba(0,0,0,0.07)"}
                      :as props}]
  [:div.mdc-linear-progress.mdc-linear-progress--indeterminate
   (-> {:role "progressbar"
        :style (merge (cond-> {:height height}
                              bg-color (assoc :background-color bg-color))
                      style)}
       (v/merge-props
        (dissoc props :height :style :color :bg-color)))
   [:div.mdc-linear-progress__bar.mdc-linear-progress__primary-bar
    {:style {:color color}}
    [:span.mdc-linear-progress__bar-inner]]
   [:div.mdc-linear-progress__bar.mdc-linear-progress__secondary-bar
    {:style {:color color}}
    [:span.mdc-linear-progress__bar-inner]]])
